import { PRODUCT_TABLE_TYPES } from '../../client/lib/constants';

const tableComponent = PRODUCT_TABLE_TYPES.STANDARD;

const columns = (id) => [
  {
    name: 'title',
    elements: [
      {
        type: 'EditableQuickFacts',
        dataDependency: {
          rawMappings: {
            value: `savings.allProducts.${id}.apy.content`,
          },
        },
        props: {
          description: 'annotation time!',
        },
      },
    ],
  },
  {
    name: 'another title',
    elements: [
      {
        type: 'CollapsibleParagraph',
        props: {
          title: 'Why we like it',
        },
      },
    ],
  },
  {
    name: 'title 3',
    elements: [
      {
        type: 'EditableQuickFacts',
      },
    ],
  },
  {
    name: 'title 4',
    elements: [
      {
        type: 'EditableQuickFacts',
      },
    ],
  },
];

export default {
  columns,
  tableComponent,
};
